import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { FormFieldsGroups } from "@ssf/components";
import { DupeDialog, useDupe } from "./index.js";
export const MemberForm = ({ schema, onDupe, schemas, watch, ...formFieldProps }) => {
    const memberWatch = (() => {
        const query = ["firstname", "lastname", "birthday"];
        const [firstname, lastname, birthday] = watch(query);
        return { firstname, lastname, birthday };
    })();
    const { dupes, showDialog, toggleDialog } = useDupe(memberWatch, !!onDupe &&
        schema
            .pick({
            firstname: true,
            lastname: true,
            birthday: true,
        })
            .safeParse(memberWatch).success);
    return (_jsxs(_Fragment, { children: [_jsx(FormFieldsGroups, { schemas: schemas, 
                // @ts-ignore
                formFieldProps: formFieldProps, autoFocus: true }), onDupe && dupes && (_jsx(DupeDialog, { query: memberWatch, dupes: dupes, showDialog: showDialog, onSelect: (dupe) => {
                    toggleDialog();
                    onDupe(dupe);
                }, onClose: toggleDialog }))] }));
};
//# sourceMappingURL=MemberForm.js.map